import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[24],
		padding: SPACE[24],
	},
	header: {
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'space-between',
		gap: SPACE[16],
		flexWrap: 'wrap',
	},
	heading: {
		fontFamily: THEME.typography.fontFamilies.sora,
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.dark,
		margin: 0,
	},
	subheading: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		margin: `${SPACE[4]}px 0 0`,
		maxWidth: '68ch',
	},
	controls: {
		display: 'flex',
		alignItems: 'center',
		gap: SPACE[16],
		flexWrap: 'wrap',
	},
	searchInput: {
		flex: 1,
		minWidth: 220,
		maxWidth: 420,
	},
	selectionBar: {
		display: 'flex',
		alignItems: 'center',
		gap: SPACE[16],
		padding: `${SPACE[8]}px ${SPACE[16]}px`,
		backgroundColor: THEME.colors.background.main,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
	},
	selectionCount: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
		marginRight: 'auto',
	},
	folderPicker: {
		minWidth: 240,
	},
	headerActions: {
		display: 'flex',
		alignItems: 'center',
		gap: SPACE[8],
	},
});

export const fileStyles = StyleSheet.create({
	dropzoneWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[16],
		paddingTop: SPACE[16],
	},
	dropzone: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		border: `2px dashed ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		padding: SPACE[32],
		cursor: 'pointer',
		transition: 'all 0.2s',
		':hover': {
			borderColor: THEME.colors.primary.main,
			backgroundColor: THEME.colors.primary.light,
		},
		'[data-drag-active]': {
			borderColor: THEME.colors.primary.main,
			backgroundColor: THEME.colors.hover.light,
		},
	},
	dropzoneContent: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: SPACE[16],
		textAlign: 'center',
	},
	dropzoneIcon: {
		width: 64,
		height: 64,
		color: THEME.colors.icon.gray,
	},
	dropzoneTitle: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		margin: 0,
	},
	dropzoneDescription: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		margin: 0,
		maxWidth: '46ch',
	},
	fileInput: {
		display: 'none',
	},
	rejectedFiles: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
		padding: SPACE[8],
		backgroundColor: THEME.colors.danger.light,
		color: THEME.colors.danger.dark,
		borderRadius: THEME.common.borderRadius,
		fontSize: THEME.typography.fontSizes.sm,
	},
});
